module.exports = __webpack_public_path__ + "03_veryshort_brown.4e587fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_veryshort_brown.png
// module id = yUpp
// module chunks = 0